import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/views/layout.vue'
import solutions from '@/views/solutions/solutions.vue'
import solutionsDetail from '@/views/solutions/solutionsDetail.vue'
import products from '@/views/products/products.vue'
import productsDetail from '@/views/products/productsDetail.vue'
import productsDetailTwo from '@/views/products/productsDetailTwo.vue'
import productsDetailThree from '@/views/products/productsDetailThree.vue'
import companyNews from '@/views/companyNews/companyNews.vue'
import companyNewsDetail from '@/views/companyNews/companyNewsDetail.vue'
import companyOverview from '@/views/companyOverview/companyOverview.vue'
import contractUs from '@/views/contractUs/contractUs.vue'
import roboticDog from '@/views/robotic/roboticDog.vue'
import unmannedAerialVehicle from '@/views/robotic/unmannedAerialVehicle.vue'
import unmannedAerialVehicleDetail from '@/views/robotic/unmannedAerialVehicleDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: layout,
    children: [
      {
        path: '/solutions',
        name: '',
        component: solutions,
      },
      {
        path: '/solutionsDetail',
        name: '',
        component: solutionsDetail,
      },
      {
        path: '/products',
        name: 'products',
        component: products,
      },
      {
        path: '/productsDetail',
        name: '',
        component: productsDetail,
      },
      {
        path: '/productsDetailTwo',
        name: '',
        component: productsDetailTwo,
      },
      {
        path: '/productsDetailThree',
        name: '',
        component: productsDetailThree,
      },
      {
        path: '/companyNews',
        name: '',
        component: companyNews,
      },
      {
        path: '/companyNewsDetail',
        name: '',
        component: companyNewsDetail,
      },
      {
        path: '/companyOverview',
        name: '',
        component: companyOverview,
      },
      {
        path: '/contractUs',
        name: '',
        component: contractUs,
      },
      {
        path: '/roboticDog',
        name: '',
        component: roboticDog,
      },
      {
        path: '/unmannedAerialVehicle',
        name: '',
        component: unmannedAerialVehicle,
      },
      {
        path: '/unmannedAerialVehicleDetail',
        name: '',
        component: unmannedAerialVehicleDetail,
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})


router.afterEach((to, from, nex) => {
  // 切换路由时，回到顶部
  window.scrollTo(0, 0)
})
export default router
